import { orderCodeActions } from '../../services';

export const orderCodeReducer = ( state = {}, action ) => {
  switch ( action.type ) {
    case orderCodeActions.FOUND:
      return { ...state, [action.code]: {
        ...state[action.code],
        productCode: action.payload
      } };
    case orderCodeActions.RETRIEVED:
      return { ...state, [action.code]: {
        ...state[action.code],
        configuration: action.payload 
      } };
  }
  return state;
};